import React, { useRef, useState } from 'react';
import '../styles/scratchLab.css';

const SCRATCH_GUI_URL = 'https://scratch-gui-minversity-production.up.railway.app';

export default function ScratchLab({
  moduleId,
  blockId,
  mode = 'free',
  tasks = [],
  height = 580,
}) {
  const iframeRef = useRef(null);
  const [checkedTasks, setCheckedTasks] = useState({});

  // Construct the project URL served by our own backend
  const projectUrl = moduleId && blockId
    ? `${window.location.origin}/api/modules/${moduleId}/scratch/${blockId}`
    : null;

  // Pass it into TurboWarp via ?project_url= query param
  const iframeSrc = projectUrl
    ? `${SCRATCH_GUI_URL}/editor.html?project_url=${encodeURIComponent(projectUrl)}`
    : `${SCRATCH_GUI_URL}/editor.html`;

  const allDone = tasks.length > 0 && tasks.every((_, i) => checkedTasks[i]);

  const toggleTask = (index) => {
    setCheckedTasks(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="scratch-lab" style={{ '--scratch-height': `${height}px` }}>
      {mode === 'guided' && tasks.length > 0 && (
        <aside className="scratch-lab__tasks">
          <h4 className="scratch-lab__tasks-title">Your Tasks</h4>
          <ul className="scratch-lab__task-list">
            {tasks.map((task, i) => (
              <li
                key={i}
                className={`scratch-lab__task-item${checkedTasks[i] ? ' scratch-lab__task-item--done' : ''}`}
                onClick={() => toggleTask(i)}
              >
                <span className="scratch-lab__task-check">
                  {checkedTasks[i] ? '✓' : '○'}
                </span>
                <span className="scratch-lab__task-text">{task}</span>
              </li>
            ))}
          </ul>
          {allDone && (
            <div className="scratch-lab__tasks-complete">
              All tasks complete!
            </div>
          )}
        </aside>
      )}
      <div className="scratch-lab__editor">
        <iframe
          ref={iframeRef}
          src={iframeSrc}
          className="scratch-lab__iframe"
          allow="microphone; camera"
          title="Scratch Editor"
        />
      </div>
    </div>
  );
}
